<template>
  <div class="chart_color_setting cx_style deng">
    <label class="font14 inlineMiddle flex_box">
      <div>{{ title }}</div>
      <div><span @click="refreshColor" class="icon-portal-refresh icon" /></div>
    </label>
    <div class="event_box" ref="transition" :style="getStyle">
      <transition-group tag="div">
        <div
          :style="getDragBoxStyle(index)"
          :class="['seting_box', 'mt8', dragging === index ? 'color-picker-setting drag_move' : '']"
          v-for="(itemColor, index) in colors"
          :key="itemColor.offset"
        >
          <div class="flex_box setting_item">
            <color-picker class="color_picker" @change="changeColor(index, $event)" :color="itemColor.color" />
            <div class="right_btn">
              <div v-if="!index" @click="addColor" class="left_icon icon_box">
                <div class="icon-portal-round-add icon"></div>
              </div>
              <div v-else @click="delItemColor(index)" class="left_icon icon_box">
                <div class="icon-portal-round-sub icon"></div>
              </div>
              <div @mousedown.prevent="mouseDown(index, $event)" class="icon_box icondrag">
                <div class="icon-portal-drag-move icon"></div>
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { _throttle } from "utils"
export default {
  name: "chartColorSetting",
  props: {
    color: {
      type: String | Object,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    lineDirection: {
      type: String,
      default: "x"
    }
  },
  data() {
    return {
      dragging: false,
      dragBoxT: 0,
      dragBoxL: 0,
      mouseL: 0,
      mouseT: 0,
      mouseToDragBoxL: 0,
      mouseToDragBoxT: 0,
      dragBoxW: 0,
      dragBoxH: 0,
      boxT: undefined,
      baseColor: {
        type: "linear",
        x: 0,
        y: 0,
        x2: this.lineDirection === "x" ? 1 : 0,
        y2: this.lineDirection === "x" ? 0 : 1,
        colorStops: [
          {
            offset: 0,
            color: "red" // 0% 处的颜色
          }
        ],
        global: false // 缺省为 false
      }
    }
  },
  computed: {
    getStyle() {
      return {
        "--colorPickerDragMoveBgColor": this.request_prefix.includes("bigScreen")
          ? "(9, 90, 217, 0.01)"
          : "(29, 114, 248, 0.01)",
        "--dragMode": this.dragging === false ? "pointer" : ""
      }
    },
    getDragBoxStyle() {
      return function (index) {
        const check = this.dragging === false || (typeof this.dragging !== Boolean && this.dragging !== index)
        return {
          left: this.mouseL - this.dragBoxL - this.mouseToDragBoxL + 2 + "px",
          top: this.mouseT - this.dragBoxT - this.mouseToDragBoxT - 6 + "px",
          width: check ? "100%" : this.dragBoxW + "px",
          height: check ? "100%" : this.dragBoxH + "px",
          position: check ? "" : "fixed",
          cursor: check ? "" : "grabbing"
          // position: "fixed"
        }
      }
    },
    colors: {
      get() {
        if (typeof this.color === "string") {
          const _color = JSON.parse(JSON.stringify(this.baseColor))
          _color.colorStops[0].color = this.color
          this.$emit("update:color", _color)
          return _color.colorStops
        } else {
          return this.color.colorStops
        }
      }
    }
  },
  methods: {
    // dragOver: _throttle(function (e) {
    //   if (this.dragging !== false) {
    //     const box = this.$refs.transition.$el.getBoundingClientRect()
    //     this.boxT = box.top
    //   }
    // }, 200),

    refreshColor() {
      const color = this.deep(this.color)
      color.colorStops = [color.colorStops[0]]
      this.$emit("update:color", color)
    },
    addColor() {
      const color = this.deep(this.color)
      color.colorStops.push(this.deep(color.colorStops[color.colorStops.length - 1]))
      color.colorStops.forEach((item, index, array) => {
        item.offset = index ? (index === array.length - 1 ? 1 : index * (1 / (array.length - 1)).toFixed(3)) : 0
      })
      this.$emit("update:color", color)
    },
    changeColor(index, newColor) {
      const color = this.deep(this.color)
      color.colorStops[index].color = newColor
      this.$emit("update:color", color)
    },
    delItemColor(index) {
      const color = this.deep(this.color)
      color.colorStops.splice(index, 1)
      color.colorStops.forEach((item, index, array) => {
        item.offset = index ? (index === array.length - 1 ? 1 : index * (1 / (array.length - 1)).toFixed(3)) : 0
      })
      this.$emit("update:color", color)
    },
    deep(obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    stopChangePosition(dropColor, dropIndex, e) {
      const { fromColor, fromIndex, uid } = JSON.parse(e.dataTransfer.getData("dragColor"))
      if (uid !== this._uid) return
      const color = this.deep(this.color)
      color.colorStops[fromIndex].color = dropColor
      color.colorStops[dropIndex].color = fromColor
      this.$emit("update:color", color)
    },
    startChangePosition(color, index, e) {
      e.dataTransfer.effectAllowed = "all"
      e.dataTransfer.setData("dragColor", JSON.stringify({ fromColor: color, fromIndex: index, uid: this._uid }))
    },
    mouseDown(index, e) {
      this.getDragBoxPositionAndSize()
      this.getMousePosition(e)
      this.handleMouseMove(e)
      this.dragging = index
      window.addEventListener("mousemove", this.handleMouseMove) //鼠标移动时 框框跟随鼠标
      window.addEventListener("mouseup", this.clearEventListener)
    },
    clearEventListener(e) {
      const mouseT = e.clientY
      const boxEl = this.$refs.transition
      const boxProperty = boxEl.getBoundingClientRect()
      if (this.checkMousePosition(e, boxEl, boxProperty)) {
        this.updateColors(mouseT, boxEl, boxProperty, this.dragging)
      }
      this.dragging = false
      window.removeEventListener("mousemove", this.handleMouseMove)
      window.removeEventListener("mouseup", this.clearEventListener)
    },
    //检查鼠标在不在盒子内
    checkMousePosition(e, boxEl, boxProperty) {
      const mouseT = e.clientY, //鼠标横轴位置
        mouseL = e.clientX, //鼠标纵轴位置
        boxLeftStart = boxProperty.left, //盒子横轴起始位置
        boxTopStart = boxProperty.top, //盒子纵轴起始位置
        boxStyles = getComputedStyle(boxEl),
        boxW = Number(boxStyles.getPropertyValue("width").slice(0, -2)), //盒子宽度
        boxH = Number(boxStyles.getPropertyValue("height").slice(0, -2)), //盒子高度
        boxLeftEnd = boxLeftStart + boxW, //盒子横轴结束位置
        boxTopEnd = boxTopStart + boxH //盒子纵轴结束位置
      return mouseT > boxTopStart && mouseT < boxTopEnd && mouseL > boxLeftStart && mouseL < boxLeftEnd
    },

    /**
     * @param {number} mouseT 鼠标相对于屏幕的top
     * @param {number} boxEl 当前颜色选择器外层盒子dom节点
     * @param {number} currentIndex 当前选中的颜色的index
     */
    updateColors(mouseT, boxEl, boxProperty, currIndex) {
      const colors = this.deep(this.color) //当前的渐变色数据数组
      const colorStops = colors.colorStops
      const nowColors = colorStops.splice(currIndex, 1)[0] //当前选中的渐变色颜色数据
      const box = getComputedStyle(boxEl) //当前组件的v-for外层盒子
      const boxH = Number(box.getPropertyValue("height").slice(0, -2)) //盒子高度
      const itemH = boxH / colorStops.length //单个颜色设置项item的高度
      const mouseToBoxTop = mouseT - boxProperty.top //鼠标到盒子顶部的高度
      const dropIndex = Math.ceil(mouseToBoxTop / itemH) //鼠标放开时在第几个item上，此处需要-1
      colorStops.splice(dropIndex - 1, 0, nowColors)
      colorStops.forEach((item, index, array) => {
        item.offset = index ? (index === array.length - 1 ? 1 : index * (1 / (array.length - 1)).toFixed(3)) : 0
      })
      this.$emit("update:color", colors)
    },
    getDragBoxPositionAndSize() {
      const el = this.$el.getElementsByClassName("setting_item")[0]
      const dragEl = el.getElementsByClassName("icondrag")[0]
      this.dragBoxW = el.offsetWidth
      this.dragBoxH = el.offsetHeight
      const iconDragPadding = (24 - 16) / 2
      this.dragBoxL = el.offsetWidth - dragEl.offsetWidth + iconDragPadding
      this.dragBoxT = el.offsetHeight - dragEl.offsetHeight
    },
    getMousePosition(e) {
      this.mouseToDragBoxL = e.offsetX
      this.mouseToDragBoxT = e.offsetY
    },

    handleMouseMove: _throttle(function (e) {
      this.mouseL = e.clientX
      this.mouseT = e.clientY
    }, 1)
  }
}
</script>

<style scoped>
.color_picker {
  width: 75%;
}
.chart_color_setting {
  position: relative;
}
.seting_box {
  border: 1px solid;
  color: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flex_box {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}
.right_font {
  position: absolute;
  right: 10px;
  text-align: right;
}
.icon {
  font-size: 16px;
  color: var(--iconColor);
}
.icon:hover {
  cursor: pointer;
}
.mr145 {
  margin-right: 14.5px;
}
.right_btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.icon_box {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.left_icon {
  margin-right: 6px;
}
.drag_move {
  background: var(--dragMoveBgColor) !important;
  box-sizing: border-box;
  border-color: var(--dragMoveBorderColor);
  z-index: 100;
  /* cursor: pointer !important; */
}

.color-picker-setting ::v-deep .color-picker-container {
  background-color: var(--colorPickerDragMoveBgColor) !important;
}
.icon_box:hover {
  cursor: var(--dragMode);
  background: var(--inputBackGround);
  border-radius: 4px;
}
.mask_top {
  position: absolute;
  width: 100%;
  height: 5px;
  left: 0;
  top: 0;
  background: transparent;
}
.mask_bottom {
  position: absolute;
  width: 100%;
  height: 5px;
  left: 0;
  bottom: 0;
  background: transparent;
}
.mask_left {
  position: absolute;
  width: calc(100% - 24px);
  height: 100%;
  top: 0;
  left: 0;
  background: transparent;
}
</style>
